export default [
	{
		title: 'Articles of Incorporation',
		href: '/documents/articles-of-incorporation',
		description: 'of Clearwater Farms Unit #1 Property Owners Association',
	},
	{
		title: 'By-Laws',
		href: '/documents/by-laws',
		description: 'of Clearwater Farms Property Owners Association',
	},
	{
		title: 'Rules and Regulations',
		href: '/documents/rules-and-regulations',
		description: 'Document dated 1/9/2025',
	},
	{
		title: 'CC&Rs',
		href: '/documents/cc-and-r-s',
		description: 'Declaration of Conditions, Covenants and Restrictions',
	},
	{
		title: 'Irrigation Info',
		href: '/documents/irrigation-information',
		description: 'Basic Irrigation Information',
	},
	{
		title: 'Policies & Procedures',
		href: '/documents/policies-and-procedures',
		description: 'Document dated 8/1/2024',
	},
	{
		title: 'Annual Budget',
		href: '/pdf/budget-2025.pdf',
		description: 'for 2025',
	},
	{
		title: 'Year End Statement & Balance Sheet',
		href: '/pdf/year-end-2025.pdf',
		description: 'Year Ending 2024',
	},
	{
		title: 'Compilation Report',
		href: '/pdf/compilation-report-2024.pdf',
		description: 'Year Ending 2024',
	},
	{
		title: 'Violation and Fine Policy',
		href: '/documents/violation-and-fine-policy',
		description: 'Document dated 10/2024',
	},
	{
		title: 'Collection Policy',
		href: '/pdf/collection-policy.pdf',
		description: 'Collection Policy Steps for CPMC',
	},
	// {
	// 	title: 'Board Education Presentation',
	// 	href: '/pdf/board-training.pdf',
	// },
	{
		title: 'Messaging Consent Policy',
		href: '/documents/messaging-consent-policy',
		description: 'for CFPOA Communications and Notifications',
	},
]
